const websites = [
  {
    id: 'codeur',
    name: 'Codeur.com',
    link: 'https://www.codeur.com'
  }, {
    id: 'graphiste',
    name: 'Graphiste.com',
    link: 'https://graphiste.com'
  }, {
    id: 'redacteur',
    name: 'Redacteur.com',
    link: 'https://www.redacteur.com'
  }, {
    id: 'traduc',
    name: 'Traduc.com',
    link: 'https://traduc.com'
  }, {
    id: 'crm',
    name: 'Facture.net',
    link: 'https://www.facture.net'
  }, {
    id: 'seo',
    badge: {
      label: 'NOUVEAU',
      color: '#A52EED'
    },
    name: 'Stratégie SEO',
    link: 'https://www.redacteur.com/packs-strategie-contenu-seo'
  }
]

const codeurTopbar = function (selector = 'codeur-topbar') {
  const el = document.getElementById(selector) // define target wrapper element
  const template = websitesTemplate(websites) // generate topbar template
  el.classList.add('_codeur-topbar') // add topbar class to wrapper

  el.innerHTML = template // inject template to wrapper
}

const websitesTemplate = function (websites) {
  const template = `
    <ul class="_codeur-topbar-websites container">
      ${websites.map((website) => websiteTemplate(website)).join('')}
    </ul>
  `

  return template
}

const websiteTemplate = function (website) {
  const { id, link, name, badge } = website
  const template = `
    <li class="${websiteClasses(id, link, badge)}">
      <a href="${urlGenerator(link)}" rel="nofollow" target="_blank">
        ${badgeGenerator(badge)}
        <div class="_codeur-topbar-website">
          <div class="_codeur-topbar-website-name">${name}</div>
        </div>
      </a>
    </li>
  `

  return template
}

const websiteClasses = function (id, link, badge) {
  const classes = []
  classes.push(`_codeur-topbar-${id}`)
  if (isCurrentWebsite(link)) classes.push('_codeur-topbar-current-website')
  if (badge) classes.push('_codeur-topbar-website-with-badge')
  return classes.join(' ')
}

const isCurrentWebsite = function (link) {
  return link.indexOf(window.location.hostname) !== -1 ? '_codeur-topbar-current-website' : null
}

const urlGenerator = function (link) {
  return link + '/?utm_source=' + window.location.hostname + '&utm_medium=topbar_widget'
}

const badgeGenerator = function (badge) {
  return badge ? `<span class="_codeur-topbar-badge" style="background-color: ${badge.color}">${badge.label}</span>` : ''
}

export default codeurTopbar
